import MessageTabButton from './MessageTabButton';

export { MessageTabButton };
export default MessageTabButton;
